module.exports = __webpack_public_path__ + "static/media/derby_photo_v2.45c94902.jpg";